import { OverlayToolbar } from "@/components/ui/overlay-toolbar";
import { selectClippingBoxEnabledForSheetCadAlignment } from "@/store/modes/sheet-cad-alignment-mode-selectors";
import { setClippingBoxEnabled } from "@/store/modes/sheet-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { ViewDiv } from "@faro-lotv/app-component-toolbox";
import {
  ClippingBoxIcon,
  FaroTooltip,
  ToolButton,
  ToolGroup,
} from "@faro-lotv/flat-ui";
import { Stack } from "@mui/material";
import type { JSX } from "react";
import { useOverlayElements, useOverlayRef } from "../overlay-elements-context";
import { SheetCadAlignmentSetElevationPanel } from "./sheet-cad-alignment-set-elevation-panel";

/**
 * SheetCadAlignmentElevation provides a view for interacting with a 3D model
 * It also renders a panel for setting elevation in a sheet-to-CAD alignment tool and a button to enable/disable a clipping box.
 *
 * @returns A layout with a panel to set elevation and a 3D model view with a toolbar
 * for interacting with the model.
 */
export function SheetCadAlignmentElevation(): JSX.Element {
  const dispatch = useAppDispatch();

  const { setSingleScreen } = useOverlayElements();
  const singleScreenRef = useOverlayRef(setSingleScreen);

  const isClippingBoxEnabled = useAppSelector(
    selectClippingBoxEnabledForSheetCadAlignment,
  );

  return (
    <Stack direction="row" sx={{ height: "100%" }}>
      <SheetCadAlignmentSetElevationPanel />

      <ViewDiv
        eventDivRef={singleScreenRef}
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Stack
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 16,
            justifyContent: "center",
          }}
        >
          <OverlayToolbar>
            <ToolGroup>
              <FaroTooltip title="Clip 3D model" placement="left">
                <ToolButton
                  selected={isClippingBoxEnabled}
                  onClick={() => {
                    dispatch(setClippingBoxEnabled(!isClippingBoxEnabled));
                  }}
                >
                  <ClippingBoxIcon />
                </ToolButton>
              </FaroTooltip>
            </ToolGroup>
          </OverlayToolbar>
        </Stack>
      </ViewDiv>
    </Stack>
  );
}
